import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { map, mergeMap } from 'rxjs/operators';

import { TechnicalResult } from '../../models/technical-result.model';
import { TechnicalResultService } from '../../services/technical-result.services';
import * as TechnicalResultActions from '../actions/technical-result.actions';

@Injectable()
export class CompanyStructureEffects {
  private readonly actions$ = inject(Actions);
  private readonly technicalResultService = inject(TechnicalResultService);

  protected getCompanyStructureByDate$ = createEffect(() =>
    this.actions$.pipe(
      ofType(TechnicalResultActions.loadTechnicalResultRequest),
      mergeMap((values) =>
        this.technicalResultService.getByDate(values.startDate).pipe(
          map((technicalResult: TechnicalResult) =>
            TechnicalResultActions.loadTechnicalResultSuccess({
              technicalResult,
            }),
          ),
        ),
      ),
    ),
  );
}
